import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DxDataGridComponent } from 'devextreme-angular';
import { genericCustomStoreService } from 'src/app/shared/services/genericCustomStore.service';
import { ObjectsService } from 'src/app/shared/services/hr/objects.service';
import { publicSettingService } from 'src/app/shared/services/hr/publicSetting';
import { SalaryService } from 'src/app/shared/services/hr/salary.service';
import { NotifyService } from 'src/app/shared/services/hr/notify.service';
import { loadMessages } from 'devextreme/localization';

@Component({
  selector: 'app-employee-resignation',
  templateUrl: './employee-resignation.component.html',
  styleUrls: ['./employee-resignation.component.scss']
})
export class EmployeeResignationComponent implements OnInit {
  @ViewChild(DxDataGridComponent) grid: DxDataGridComponent;
   customDataSource: any;
  button: any;
  addpopup: string = ''

  LOCALIZATION_LOCAL_STORAGE_KEY = "Language";
  currentLang: any;
  allEmployeesDataSource: any
  employeeDropDown: any;
  branchesDropDown: any;
  employeeStatus: any;

  constructor(public gt: genericCustomStoreService,public translate: TranslateService,  private salaryServic: SalaryService, 
    Objects: ObjectsService, public router: Router,public NotifyService: NotifyService, public _publicSettingService: publicSettingService) {
    gt.seturl("EmployeeResignation");
    gt.submit();
     this.button = Objects.button;
    this.customDataSource = gt.customDataSource;
    this.currentLang = localStorage.getItem(
      this.LOCALIZATION_LOCAL_STORAGE_KEY
    );       

    
    gt.getdropdowndata("branch").subscribe((res:any)=>{
      // this.employeeDropDown=res.data;      
      this.branchesDropDown=res;
      
    });

    gt.dropdown(`Employee/GetDropDown?isOnJobOnly=false`).subscribe((res:any)=>{
      // this.employeeDropDown=res.data;
      this.allEmployeesDataSource=res;
      this.employeeDropDown = this.allEmployeesDataSource
    })

      gt.getdropdowndata("EmployeeResignation","GetDropDown/ApprovedStatus").subscribe((res: []) => this.employeeStatus = res)
  
  
    loadMessages({
      en: { "Yes": this.translate.instant('personal.yes'), "No": this.translate.instant('personal.no') }
  });

   }

  ngOnInit(): void {
  }
  
  updateRow(e: any) {   
    e.newData = Object.assign(e.oldData, e.newData);
  }
onInitNewRow(e: any) {
  this.addpopup = this.translate.instant('tableinfo.addbutton');  
  e.data = {
    ...e.data,
    status: 1 // Set default status
  };

}

  onEditingStart() {
    this.addpopup = this.translate.instant('tableinfo.editbutton')

  }

  changesChange(e: any) {  
    console.log("Updating ...", e[0].data)  
    if(e[0].data.branchId)
      this.employeeDropDown = this.allEmployeesDataSource.filter((x:any) => x.branchId == e[0].data.branchId 
        && x.employeeWorkStatus == 1 );     
  }


  addrowfun(name: string) {
    return this.gt.addrow(name)
  }
shouldShowActionButtons = (e: any): boolean => {
  return e.row?.data?.status !== 3;
}

Saved() {
  this.employeeDropDown = this.allEmployeesDataSource;
}

}
